const zh_HK :{[key: string]: string} = {
    login:'登入',
    email:'電郵',
    cachierDesk:'收款處',
    password:'密碼',
    userNameNotNull: '電郵必須輸入',
    passwrodNotNull: '密碼必須輸入',
    historyReport:'歷史統計',
    setting:'設定',
    collectMoney:'我要收款',
    amtNotNull: '金額必須輸入',
    amtShouldBeNum:'金額必須為數字',
    amtGreaterThan0:'金額必須大於0',
    amtShouldBeInteger: '金額不能有小數',
    amt: '金額',
    remark:'備註',
    genQr:'用戶掃我',
    scanQr:'我掃用戶',
    collectQr:'收款二維碼',
    paySucc: '支付成功',
    unpaid: '未支付',
    modifyPass: '更改密碼',
    passLengthError: '密碼長度必須大於6位',
    passConfirmError: '兩次密碼不一致',
    oldPass:'舊密碼',
    newPass: '新密碼',
    confirmPass:'確認密碼',
    confirmModify: '確認修改',
    transSucc: '交易成功',
    newOrder:'新訂單',
    orderNo:'訂單號',
    buyer: '付款人',
    payTime: '支付時間',
    finish: '儲存',
    scanQrTips:'將二維碼放入框內，即可自動掃描',
    lightOn: '開燈',
    lightOff: '關燈',
    logout:'登出帳號',
    confirmLogoutMsg:'您確認要登出當前帳號麼？',
    cancel: '取消',
    confirm:'確認',
    languages: '語言',
    refunded:'已退款',
    transFailed:'交易失敗',
    refunding: '正在退款',
    refund: '退款',
    refundAmtLimit:'退款金額不能大於',
    canRefundAmt:'可退款金額',
    refundAll:'全額退款',
    refundAmt:'退款金額',
    report: '報表',
    dayReport:'日交易匯總',
    overview:'總覽',
    transNum:'交易筆數',
    fee: '手續費',
    payment: '支付',
    orderDetail: '訂單詳情',
    status:'狀態',
    transactions:'交易流水',
    noData:'暫無數據',
    noMore:'沒有更多數據',
    storeName:'門店名稱',
    employeeName:'員工名稱',
    employeeTitle:'員工職務',
    currency: '結算貨幣',
    basicInfo:'基本信息',
    keyError:'系統錯誤：密鑰錯誤',
    modifySucc:'修改成功！',
    refundSucc: '退款成功！',
    SYSTEM_ERROR:'系統繁忙，請稍後再試',
    NETWORK_ERR: '網絡錯誤',
    chooseLan:'選擇語言',
    dealing:'正在處理',
    transFailTips: '交易失敗，請重新嘗試',
    /////////2018.10.10///////////
    forgetPassword: '忘記密碼?',
    contactUs: '聯繫我們',
    contactTips: '留下您的郵箱，方便我們與您聯繫。',
    submit: '遞交',
    contactSuccTips:'提交成功，我們將儘快與您聯繫。',
    expireTime:'失效時間:',
    home: '主頁',
    bills: '對帳單',
    my: '我的',
    partialRefunded: '部分退款',
    returnLogin: '返回登入',
    saveSucc: '儲存成功!',
    todayIncome: '今日收款金額',
    todayTrans: '今日交易筆數',
    queryOrder:'訂單查詢',
    cameraNotAuthorzied: '相機未授權，請在設置中開啟權限',
    camerarollDenied: '相冊訪問權限未授權，請在設置中開啟',
    queryOrderTips: '請輸入訂單號或掃描訂單條碼',
    loading: '正在加載...',
    orderNoNotNull: '訂單號不能為空',
    oldPasswrodNotNull: '舊密碼不能為空',
    newPasswrodNotNull: '新密碼不能為空',
    confirmPasswrodNotNull: '確認密碼不能為空',
    emailNotNull: '電郵不能為空',
    //=====2018.11.14====
    employeeManage: '員工管理',
    SUPER_ADMIN: '超級管理員',
    ADMIN: '門店管理員',
    // admin: '管理員',
    CASHIER: '收銀員',
    modifyUser: '修改員工信息',
    loginNo: '登錄帳號',
    name: '員工姓名',
    phoneNumber: '手機號碼',
    role: '角色',
    newUser: '新增員工',
    add: '新增',
    userBuyFee: '用戶承擔手續費',
    userBuyFee_checkout: '用戶承擔手續費',
    delete: '刪除',
    pleaseInput: '請輸入',
    pleaseSelect: '請選擇',
    settlement: '結算中心',
    allDate: '全部日期',
    settlementAmt:'結算金額',
    merchantQr:'商戶收款碼',
    clickView: '點擊查看',
    Alipay: '支付寶',
    Wechat: '微信',
    collectAmt: '支付金額',
    collectNum: '收款筆數',
    refundNum: '退款筆數',
    orderList:'訂單列表',
    settlementDetail: '結算詳情',
    current: '當前',
    scanBarcode: '掃描條碼',
    photos: '相冊',
    noQR: '未識別到二維碼/條碼',
    deleteSucc: '移除成功！',
    emailNoValid: 'E-mail格式不合法!',
    passwordLessThan6: '密碼至少6位!',
    settled: '已結算',
    unSettled: '待結算',
    iSee: '我知道咗',
    unSettledTips: '待結算金額還未扣除手續費，因手續費涉及小數的處理，須以實際結算為準',
    voiceTip: '收款語音播報',
    //=======
    exchangeRate: '匯率',
    payCurrency: '交易貨幣',
    markupRate: '匯率上浮',
    modifyRate: '修改匯率上浮比率',
    confirmDeleteMsg:'確認刪除該用戶麼？',
    company: '公司名稱',
    contactPerson: '聯絡人',
    //=====
    storeNotNull: '必須選擇所屬店鋪',
    allStore:'所有門店',
    turnOverLineTitle:'營業額日趨勢（一周）',
    merchantStatsTitle: '店鋪今日營業額',
    turnover: '營業額',
    storeManagement: '店鋪管理',
    collapse: '收起',
    connected: '在線',
    disconnected: '斷開',
    // ====
    monthlyIncome: '本月收入金額',
    monthlyTradeNum: '本月交易筆數',
    collecting: '您正在收款：',
    scanOrEnterPayQr: '請掃描或輸入用的付款碼',
    latestOrders: '最新訂單',
    more: '查看更多',
    cancelled: '已取消',
    selectDate: '選擇日期',
    startDate: '開始日期',
    endDate: '結束日期',
    settlementStatus: '結算狀態',
    all: '全部',
    payType: '錢包',
    query: '查詢',
    export: '導出',
    clear: '清空條件',
    unknown: '未知',
    pagiPrefix: '每頁展示',
    pagiAfter: '條',
    settlementList: '結算歷史',
    settlementDate: '結算日期',
    operations: '操作',
    downloadDetail: '下載明細',
    merchantInfo: '商戶信息',
    country: '國家/地區',
    storeType: '門店類型',
    SINGLE: '單店',
    CHAIN_STORE: '連鎖店',
    paymentSettings: '支付設定',
    modify: '修訂',
    download: '下載',
    emialNotCorrect: '郵箱格式不正確',
    nameNotNull: '姓名不能為空',
    phoneNotCorrect: '手機號碼不正確',
    lastLogin: '最後登陸時間',
    deleteUser: '刪除用戶',
    developerInfo: '開發者信息',
    merchantName: '商戶名稱',
    merchantNo: '商戶號',
    view: '查看',
    storeInfo: '門店信息',
    storeId: '門店編號',
    interfaces: '可用接口',
    online: '線上',
    offline: '線下',
    webpage_api: '網站支付',
    app_api: 'APP支付',
    barcode_api: '付款碼支付',
    transqr_api: '訂單二維碼支付',
    jsapi_api: 'JS API',
    dashboard: '收銀台',
    orders: '訂單管理',
    settlements: '結算管理',
    merchant: '商戶管理',
    info: '基本信息',
    users: '員工信息',
    account:'帳戶信息',
    developer: '開發者',
    mustBeNumer:'必須為數字',
    modifyPassSucc: '修改成功，請用新密碼重新登陸',
    addUserSucc: '添加員工成功！',
    newOrderNoitf: '您有新訂單，交易金額：',
    unpaidToast: '等待用戶支付，請確認用戶是否完成支付',
    queryOrderManually: '手動查詢訂單',
    manualQueryOrderTips: '說明: 輸入或掃描訂單號手動查詢該筆訂單狀態。當用戶已支付但管理台未收到消息時可以使用該功能進行查詢。',
    findPassword: '找回密碼',
    findPasswordTips: '請填寫的登錄帳號，我們會給你發一封找回密碼的郵件，根據郵件提示找回密碼',
    send: '發送',
    backToLogin:'返回登陸',
    resetPassword: '重置密碼',
    resetPasswordTips: '您正在找回密碼，請填寫您的郵箱和新密碼。',
    sendSucc: '發送成功，請查看你的郵箱！',
    resetSucc: '重置成功，請用新密碼進行登陸！',
    reSendText: '{sencond}秒後重發',
    msg404: '對不起，您要找的頁面消失了！',
    //====
    balance: '帳戶餘額',
    unsettled: '未結算金額',
    minimum: '最低提現金額',
    minimumSettlementAmount:'起結金額',
    settlementCurrency:'結算幣種',
    withdrawal: '可提現金額',
    cash: '提現',
    bank: '提現銀行',
    accountNumber: '銀行帳號',
    accountName: '銀行戶名',
    money: '提現金額',
    cashToast: '提現金額必須大於等於最低提現金額，小於等於可提現金額',
    collection: '收款管理',
	collectionLink: '收款連結',
    createLink: '生成連結',
    storeChoose: '門店選擇',
    searchLink: '査詢連結',
    copy: '複製',
    copySuccess: '複製成功',
    copyError: '複製失敗，請手動複製',
	transactionStatus: '交易狀態',
	paid: '已支付',
	linkList: '連結清單',
    createTime: '創建時間',
    payNo: '支付訂單號',
    partnerNo: '合作夥伴訂單號',
    linkDetail: '連結詳情',
	exchangeManage: '換匯管理',
	exchangeApply: '換匯申請',
	exchangeRecords: '換匯記錄',
	canExchangeAmount: '可換匯金額',
	salesAmount: '換匯金額',
	buyingCurrency: '買入幣種',
	defaultBank: '是否使用默認銀行帳號',
	yes: '是',
	no: '否',
	bankName: '銀行名稱',
	bankNumber: '銀行帳號',
	bankAccName: '銀行戶名',
	bankAddress: '銀行地址',
	swiftcode: '銀行Swiftcode',
	exchangeDetail: '換匯詳情',
	currentCurrency: '賣出幣種',
	purchaseAmount: '買入金額',
	availableBalance: '可用餘額',
	improveBankInformation: '請完善銀行資訊！',
	sellToast: '請輸入賣出金額!',
	currencyToast: '請選擇幣種！',
	successTime: '成功時間',
	exchangeSucc: '成功',
	untreated: '未處理',
	functionToast: '您尚未開通此功能！'
}

export default zh_HK